import { EventEmitter, Injectable } from "@angular/core";
import { Direction, Directionality } from "@angular/cdk/bidi";

/**
 * CDK's default `Directionality` reads `document.documentElement.dir` once, the
 * first time anything injects it — which happens in `AppComponent`'s
 * constructor (it injects CDK `Dialog`), before `LanguageService` has
 * asynchronously loaded the user's language and set `dir`. That freezes every
 * CDK Dialog/Overlay to `ltr` for the rest of the session, even for he/ar
 * users. This reads the attribute live instead; `LanguageService` calls
 * `notifyChange()` whenever it updates `dir`, so already-open overlays and
 * ones opened later both pick up the current direction.
 */
@Injectable({
  providedIn: "root",
})
export class LiveDirectionality implements Directionality {
  readonly change = new EventEmitter<Direction>();

  get value(): Direction {
    return document.documentElement.dir === "rtl" ? "rtl" : "ltr";
  }

  notifyChange(): void {
    this.change.emit(this.value);
  }

  ngOnDestroy(): void {
    this.change.complete();
  }
}
